"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _expert = require("@/api/expert/expert");
var _school = require("@/api/school/school");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          name: [{
            required: true,
            message: "请输入专家姓名",
            trigger: "blur"
          }],
          idCard: [
          // { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            validator: _validate.validateIdNo,
            trigger: "blur"
          }],
          loginName: [{
            required: true,
            message: "请输入登录账号",
            trigger: "blur"
          }],
          phoneNumber: [{
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }, {
            validator: _validate.validatePhoneTwo,
            trigger: "blur"
          }],
          mail: [{
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          }, {
            validator: _validate.validateEMail,
            trigger: "blur"
          }]
          // schoolId: [
          //   { required: true, message: "请输入所属学校", trigger: "blur" },
          // ],
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "专家姓名：",
          isDisabled: false,
          placeholder: "请输入专家姓名",
          prop: "name",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "身份证号：",
          prop: "idCard",
          value: "",
          placeholder: "请输入身份证号",
          span: 12
        }, {
          type: "input",
          label: "登录账号：",
          prop: "loginName",
          placeholder: "请输入登录账号",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "手机号：",
          placeholder: "请输入手机号",
          prop: "phoneNumber",
          value: "",
          span: 12
        }, {
          type: "input",
          label: "邮箱：",
          placeholder: "请输入邮箱地址",
          prop: "mail",
          value: "",
          span: 12
        }, {
          span: 12,
          type: "selectX",
          label: "所属学校：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入所属学校",
          prop: "schoolId",
          value: [],
          options: []
        }]
      },
      school: {
        bureauId: "",
        queryValue: "",
        type: 0
      },
      page: {
        pageNumber: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      e.isExpert = 1;
      (0, _expert.expertAdd)(e).then(function () {
        _this.$message.success("操作成功。");
        _this.$router.push("/technocracyTest/technocracy");
      });
    },
    // 获取学校列表
    getSchoolList: function getSchoolList() {
      var _this2 = this;
      (0, _school.schoolList)({
        bureauId: this.school.bureauId,
        queryValue: this.school.queryValue,
        type: this.school.type,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNumber
      }).then(function (res) {
        var data = res.data;
        var formItem = _this2.formData.formItem;
        formItem[5].options = data.list;
      });
    }
  },
  created: function created() {
    this.getSchoolList();
  }
};